import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import GridReal from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { ImportService } from '~/services/import';
import { Roles } from '~/types/types';
import { usePollingSubscription } from '~/util/use-subscription';
import { ImportState } from '~/api/import';

export const ImportRoles: Readonly<Roles[]> = [Roles.Import];

const Grid = styled(GridReal)({
  padding: '4px',
});

const ImportQueue = (props: any) => {
  const [imports, refreshImports] = usePollingSubscription(ImportService.getQueue(), [], 10000);

  const removeImportJob = (importJob: any) => {
    if (!confirm('Är du säker?')) {
      return;
    }

    ImportService.delete(importJob.id).subscribe(() => refreshImports());
  };

  const getStatus = (importJob: any) => {
    if (importJob.state == ImportState.Active) {
      return <CircularProgress size={20} />;
    } else if (importJob.state == ImportState.Error) {
      return (
        <Icon color="error">
          <ErrorIcon />
        </Icon>
      );
    } else if (importJob.state == ImportState.Finished) {
      return (
        <Icon color="primary">
          <CheckIcon />
        </Icon>
      );
    } else {
      return (
        <Icon color="primary">
          <QueryBuilderIcon />
        </Icon>
      );
    }
  };

  const useStyles = makeStyles()({
    deleteIcon: {
      padding: '4px',
    },
  });

  const { classes } = useStyles();
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Status</TableCell>
          <TableCell>Datum</TableCell>
          <TableCell>Användarnamn</TableCell>
          <TableCell>Filnamn</TableCell>
          <TableCell>Importtyp</TableCell>
          <TableCell>Meddelande</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {imports.map((importJob: any, index: number) => {
          return (
            <TableRow key={index} selected={importJob.active}>
              <TableCell>{getStatus(importJob)}</TableCell>
              <TableCell>{importJob.created.split('.')[0].replace('T', ' ')}</TableCell>
              <TableCell>{importJob.principalName}</TableCell>
              <TableCell>{importJob.filename}</TableCell>
              <TableCell>{importJob.importType}</TableCell>
              <TableCell>
                <Typography variant={'body2'} color={importJob.state == ImportState.Error ? 'error' : 'initial'}>
                  {importJob.status}
                </Typography>
              </TableCell>
              <TableCell>
                {importJob.state !== ImportState.Active && (
                  <IconButton className={classes.deleteIcon} onClick={() => removeImportJob(importJob)} size="large">
                    <DeleteIcon titleAccess="Delete" color={'action'} />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default function ImportsPage(props: any) {
  return (
    <>
      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Typography variant="h4">Importer</Typography>
          <Typography>
            Notera att den här sidan uppdateras automatiskt var 10e sekund. Färdiga importer tas automatiskt bort efter
            ett dygn.
          </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Button variant="contained" color={'primary'} href="/import">
            Importera fil
          </Button>
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Typography variant="h5">Importer i kö</Typography>
          <ImportQueue />
        </Grid>
      </Grid>
    </>
  );
}
